// -----------------------------------------------------------
// FloraIQ - FieldCollectionStagePanel (Aba Etapa 3 - Cadastro de Campo)
// -----------------------------------------------------------

import { fieldProduction } from "@/mocks/operational";

export default function FieldCollectionStagePanel() {
  return (
    <div className="space-y-5">
      {/* Cards de produção */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[
          { label: "Árvores Cadastradas Hoje", value: "287", icon: "ri-plant-line", variant: "success" },
          { label: "Vistorias Realizadas", value: "1.842", icon: "ri-clipboard-line", variant: "info" },
          { label: "Fotos Capturadas", value: "5.536", icon: "ri-camera-line", variant: "info" },
          { label: "Registros Offline", value: "43", icon: "ri-cloud-off-line", variant: "warning" },
          { label: "Pendências Sincronização", value: "12", icon: "ri-refresh-line", variant: "warning" },
          { label: "Técnicos em Campo", value: "6", icon: "ri-team-line", variant: "success" },
          { label: "Cobertura por Bairro", value: "78%", icon: "ri-map-pin-line", variant: "info" },
          { label: "Árvores sem Foto", value: "24", icon: "ri-camera-off-line", variant: "danger" },
        ].map((card) => (
          <div key={card.label} className={`rounded-card border border-background-200/70 p-3 ${
            card.variant === "success" ? "bg-green-50/50" : card.variant === "info" ? "bg-accent-50/50" : card.variant === "warning" ? "bg-orange-50/50" : "bg-red-50/50"
          }`}>
            <div className="flex items-center gap-2">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                card.variant === "success" ? "bg-green-100 text-green-600" : card.variant === "info" ? "bg-accent-100 text-accent-600" : card.variant === "warning" ? "bg-orange-100 text-orange-600" : "bg-red-100 text-red-600"
              }`}>
                <i className={`${card.icon} text-sm`}></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">{card.label}</p>
                <p className="text-lg font-bold text-foreground-900 font-heading">{card.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tabela de produção */}
      <div className="rounded-card border border-background-200/70 p-4">
        <h4 className="text-sm font-bold text-foreground-900 mb-3">Produção de Campo por Técnico</h4>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/50">
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Técnico</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Equipe</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Bairro</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Árvores</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Vistorias</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Fotos</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Pendências</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Sincronização</th>
                <th className="text-left px-2 py-2 text-[10px] font-medium text-foreground-500 uppercase">Status</th>
              </tr>
            </thead>
            <tbody>
              {fieldProduction.map((fp, idx) => (
                <tr key={idx} className="border-b border-background-100/70 hover:bg-background-50/50">
                  <td className="px-2 py-2 text-xs font-medium text-foreground-800">{fp.tecnico}</td>
                  <td className="px-2 py-2 text-xs text-foreground-600">{fp.equipe}</td>
                  <td className="px-2 py-2 text-xs text-foreground-600">{fp.bairro}</td>
                  <td className="px-2 py-2 text-xs font-bold text-foreground-800">{fp.arvoresCadastradas.toLocaleString("pt-BR")}</td>
                  <td className="px-2 py-2 text-xs text-foreground-600">{fp.vistorias.toLocaleString("pt-BR")}</td>
                  <td className="px-2 py-2 text-xs text-foreground-600">{fp.fotos.toLocaleString("pt-BR")}</td>
                  <td className="px-2 py-2">
                    <span className={`text-xs font-medium ${fp.pendencias > 10 ? "text-red-600" : fp.pendencias > 5 ? "text-orange-600" : "text-foreground-600"}`}>
                      {fp.pendencias}
                    </span>
                  </td>
                  <td className="px-2 py-2 text-xs text-foreground-600">{fp.ultimaSincronizacao}</td>
                  <td className="px-2 py-2">
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${
                      fp.status === "Ativo" ? "bg-green-100 text-green-700" : "bg-orange-100 text-orange-700"
                    }`}>{fp.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mapa mockado */}
      <div className="rounded-card border border-background-200/70 p-4">
        <h4 className="text-sm font-bold text-foreground-900 mb-3">Mapa de Cobertura de Campo</h4>
        <div className="relative w-full h-48 bg-[#1a1a2e] rounded-lg overflow-hidden">
          <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(circle at 30% 40%, #1B6E4F 1px, transparent 1px), radial-gradient(circle at 60% 30%, #1B6E4F 1px, transparent 1px), radial-gradient(circle at 45% 60%, #1B6E4F 1px, transparent 1px), radial-gradient(circle at 20% 70%, #F57C00 1px, transparent 1px), radial-gradient(circle at 75% 50%, #1B6E4F 1px, transparent 1px), radial-gradient(circle at 70% 20%, #D32F2F 1px, transparent 1px)", backgroundSize: "40px 40px" }}></div>
          <div className="absolute bottom-3 left-3 right-3 flex items-center gap-4 text-[10px]">
            <span className="flex items-center gap-1 text-white/70"><span className="w-2 h-2 rounded-full bg-green-500"></span> Cadastrado</span>
            <span className="flex items-center gap-1 text-white/70"><span className="w-2 h-2 rounded-full bg-orange-500"></span> Pendente</span>
            <span className="flex items-center gap-1 text-white/70"><span className="w-2 h-2 rounded-full bg-red-500"></span> Crítico</span>
            <span className="flex items-center gap-1 text-white/70 ml-auto">Área: 4,8 km² | Cobertura: 78%</span>
          </div>
        </div>
      </div>
    </div>
  );
}